<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/military-students`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование данных обучающегося</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">
      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-5">
              ИИН
            </label>
            <div class="col-md-7">
              <input class="form-control" id="iin" type="text"
                     :disabled="true"
                     v-model="student.iin"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="lastname" class="form-label col-md-5">
              Фамилия
            </label>
            <div class="col-md-7">
              <input class="form-control" id="lastname" type="text"
                     :disabled="true"
                     v-model="student.lastname"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="firstname" class="form-label col-md-5">
              Имя
            </label>
            <div class="col-md-7">
              <input class="form-control" id="firstname" type="text"
                     :disabled="true"
                     v-model="student.firstname"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="patronymic" class="form-label col-md-5">
              Отчество
            </label>
            <div class="col-md-7">
              <input class="form-control" id="patronymic" type="text"
                     :disabled="true"
                     v-model="student.patronymic">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isFirstCourse" class="form-label col-md-5">
              1 курс (новый прием)
            </label>
            <div class="col-md-7">
              <select v-model="student.isFirstCourse" id="isFirstCourse"
                      required
                      :disabled="isDisabled()"
                      class="form-select">
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="!isHourCalculationType()">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="monthCount" class="form-label col-md-5">
              Количество месяцев по выплате военной кафедры
            </label>
            <div class="col-md-2">
              <input class="form-control" id="monthCount"
                     type="number" :min="0" :max="20" :step="1"
                     :disabled="isDisabled()"
                     v-on:change="onChange()"
                     v-model="student.monthCount"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="isHourCalculationType()">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="trainingHours" class="form-label col-md-5">
              Количество часов по военной кафедре
            </label>
            <div class="col-md-2">
              <input class="form-control" id="trainingHours"
                     type="number" :min="0" :max="588" :step="1"
                     :disabled="isDisabled()"
                     v-on:change="onChange()"
                     v-model="student.trainingHours"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="isHourCalculationType()">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="providedHours" class="form-label col-md-5">
              Предоставленные часы
            </label>
            <div class="col-md-2">
              <input class="form-control" id="providedHours"
                     type="number" :min="0" :max="588" :step="1"
                     :disabled="isDisabled()"
                     v-model="student.providedHours"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="orderDate" class="form-label col-md-5">
              Дата поступления на военную кафедру
            </label>
            <div class="col-md-2">
              <input
                  id="orderDate"
                  type="date"
                  v-model="student.orderDate"
                  :disabled="isDisabled()"
                  class="form-control"
                  required
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="orderDepartureDate" class="form-label col-md-5">
              Дата выбытия с военной кафедры
            </label>
            <div class="col-md-2">
              <input
                  id="orderDepartureDate"
                  type="date"
                  v-model="student.orderDepartureDate"
                  :disabled="isDisabled()"
                  class="form-control"
                  required
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="orderNumber" class="form-label col-md-5">
              Номер приказа
            </label>
            <div class="col-md-7">
              <input class="form-control" id="orderNumber" type="text"
                     :disabled="isDisabled()"
                     v-model="student.orderNumber"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="fileUpload" class="form-label col-md-5">
              Прикрепление документа о зачислении в военную кафедру (PDF)
            </label>
            <div class="col-md-7" v-if="file">
              <a href="javascript:void(0)" @click="downloadFile(file)">
                {{ file.name }}
              </a>

              <b-button variant="danger"
                        class="btn-sm"
                        style="margin-left: 20px"
                        v-if="canRemoveFile()"
                        @click="onClickRemoveFile()">
                Удалить
              </b-button>
            </div>
            <div class="col-md-7" v-if="!file">
              <input type="file" id="fileUpload"
                     accept=".pdf" class="form-control"
                     :disabled="isDisabled()"
                     @change="handleFileUpload( $event)"
                     required/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-5">
              Общая сумма
            </label>
            <div class="col-md-7" v-if="isHourCalculationType()">
              {{ student.trainingHours || 0 }} * 608.5 = {{ getTotalAmount(student) }}
            </div>
            <div class="col-md-7" v-if="!isHourCalculationType()">
              {{ student.monthCount || 0 }} * 17890 = {{ getTotalAmount(student) }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import militaryStudentService from "@/services/militaryStudentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import fileService from "@/services/fileService";

export default {
  components: {
    VueLoading
  },
  computed: {
    studentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      student: {
        uuid: null,
        trancheYear: null,
        trancheNumber: null,
        universityId: null,
        iin: null,
        lastname: null,
        firstname: null,
        patronymic: null,
        isFirstCourse: null,
        monthCount: 0,
        trainingHours: 0,
        providedHours: 0,
        admissionYear: null,
        orderDate: null,
        orderDepartureDate: null,
        orderNumber: null,
        fileId: null,
        totalAmount: null
      },
      file: null,
      uploadedFile: null,
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
    };
  },
  methods: {
    init() {
      this.findById(this.studentId);
    },
    async findById(studentId) {
      this.isLoading = true;
      this.student = await militaryStudentService.findById(studentId);
      if (this.student.monthCount == null) {
        this.student.monthCount = 0;
      }
      if (this.student.trainingHours == null) {
        this.student.trainingHours = 0;
      }
      if (this.student.totalAmount == null) {
        this.student.totalAmount = 0;
      }

      await this.loadFileInfo(this.student);
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;

        if (!this.fileId && this.uploadedFile) {
          const formData = new FormData();
          formData.append('studentUuid', this.student.uuid);
          formData.append('file', this.uploadedFile);

          this.file = await fileService.uploadFile(formData);
          this.student.fileId = this.file.uuid;
        }


        this.student = await militaryStudentService.save(this.student);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    async loadFileInfo() {
      if (this.student.fileId) {
        this.file = await fileService.loadFileInfo(this.student.fileId);
      }
    },
    async downloadFile(file) {
      await fileService.download(file.uuid, file.name);
    },
    canRemoveFile() {
      return delegationService.isUniversityManager();
    },
    async onClickRemoveFile() {
      const confirmed = await confirm("Вы уверены, что хотите удалить данный файл?");
      if (confirmed) {
        try {
          await fileService.deleteFileById(this.file.uuid);

          this.file = null;
          this.student.fileId = null;

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    isHourCalculationType() {
      return this.student.trancheYear != null && this.student.trancheYear >= 2025;
    },
    calcTotalSum() {
      if (this.isHourCalculationType()) {
        const trainingHours = this.student.trainingHours || 0;
        return trainingHours * 608.5;
      } else {
        const monthCount = this.student.monthCount || 0;
        return monthCount * 17890;
      }
    },
    onChange() {
      this.student.totalAmount = this.calcTotalSum();
    },
    getTotalAmount(student) {
      let totalAmount = 0;
      if (student != null && student.totalAmount != null) {
        totalAmount = student.totalAmount;
      }
      return totalAmount.toFixed(2);
    },
    isDisabled() {
      return this.hasEditPermission() === false;
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
